import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../../common/header/header.component';
import { SidebarComponent } from '../../common/slidebar/sidebar.components';
import { FaceCompareToolbarComponent } from './face-compare-toolbar/face-compare-toolbar.component';
import { FaceCompareService } from '../../../services/face-compare/face-compare.service';
import { FaceSearchTabsComponent } from '../face-search-tabs/face-search-tabs.component';
import { UserAccountService } from '../../../services/user-account/user-account.service';
import { SearchServiceStatusService } from '../../../services/search-service-status/search-service-status.service';
import { CreditsLabelPipe } from '../../../pipes/credits-label.pipe';

@Component({
  selector: 'app-face-compare',
  imports: [CommonModule,
    RouterOutlet,
    HeaderComponent,
    SidebarComponent,
    FaceCompareToolbarComponent,
    FaceSearchTabsComponent, CreditsLabelPipe],
  templateUrl: './face-compare.component.html',
  styleUrl: './face-compare.component.css',
})
export class FaceCompareComponent implements OnInit, OnDestroy {
  availableCredits: number | null = null;
  creditsLoading = true;
  isServiceDisabled = false;
  showBack = false;

  private subscription = new Subscription();

  constructor(
    private faceCompareService: FaceCompareService,
    private userAccountService: UserAccountService,
    private router: Router,
    private route: ActivatedRoute,
    private searchServiceStatusService: SearchServiceStatusService,
  ) {
    this.faceCompareService.setFeatureContext('face_compare');
  }

  ngOnInit(): void {
    this.subscription.add(
      this.searchServiceStatusService.searchServices$.subscribe((searchServices) => {
        if (searchServices) {
          this.isServiceDisabled = searchServices.face_compare === false;
        }
      }),
    );

    this.subscription.add(
      this.route.queryParamMap.subscribe(() => this.updateShowBack()),
    );

    this.subscription.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => this.updateShowBack()),
    );

    this.updateShowBack();
    this.getAvailableCredits();
  }

  private updateShowBack(): void {
    const onResults = this.router.url.includes('/face-compare/detector');
    const hasStaleId = Boolean(
      this.route.snapshot.queryParamMap.get('face_compare_id'),
    );
    this.showBack = onResults && hasStaleId;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getAvailableCredits(): void {
    this.creditsLoading = true;
    this.userAccountService.getUserProfile().subscribe({
      next: (response) => {
        const subscription = response?.data?.subscriptions?.[0] || {};
        this.availableCredits = this.userAccountService.pickAvailableCredits(response);
        this.creditsLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.availableCredits = 0;
        this.creditsLoading = false;
      },
    });
  }

  onBuyCreditsButtonClick(): void {
    this.router.navigate(['/plan-pricing']);
  }

  onBack(): void {
    this.router.navigate(['/osint-image-search/face-compare/upload'], {
      queryParams: {},
    });
  }

  onSplitViewClicked(): void {
    this.faceCompareService.triggerSplitViewDialog();
  }

  onResetAllClicked(): void {
    this.faceCompareService.clearAll();
  }
}
